export default "__VITE_ASSET__la8TNtIu__"